module.exports = __webpack_public_path__ + "static/img/homebanner1.0e2ebf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homebanner1.png
// module id = Za6x
// module chunks = 2